import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobMatchCompareModalComponent } from './job-match-compare-modal.component';
import { CandidatesPageModule } from '../../candidates-page/candidates-page.module';

@NgModule({
  declarations: [JobMatchCompareModalComponent],
  imports: [
    CommonModule,
    CandidatesPageModule
  ],
  exports: [JobMatchCompareModalComponent],
  entryComponents: [JobMatchCompareModalComponent]
})
export class JobMatchCompareModalModule { }
